((docs)=>{

    const myDoc = docs;
    let mediaQ = window.matchMedia(`(max-width: 991px)`);

    const header = myDoc.getElementById('siteHeader');
    const sticky = header.offsetTop;
    const onScroll = () => {
      if (window.scrollY > sticky) {
        header.classList.add("sticky");
      } else {
        header.classList.remove("sticky")
      }
    }
    window.addEventListener('scroll', onScroll);



    const menuDropdown = (nai) => {
      const menu = myDoc.querySelector(nai);
      const offcanv = myDoc.querySelector('.nav-min');
      //let menu = myDoc.querySelector('.nav-min-menu');
      let dropMenuItems = menu.querySelectorAll('.haveChild');
      if(mediaQ.matches) {
          let mobMnuHdr = myDoc.querySelector('.nav-min-header');
          let mobMnuCloser = myDoc.querySelector('.nav-min-close');
          Object.keys(dropMenuItems).forEach((key) => {
              let item = dropMenuItems[key].querySelector('a');
              //console.log(item);
              let subMenu = dropMenuItems[key].querySelector('.dropdown-menu');
              let chieldCloseBtn = subMenu.querySelector('.nav-min-menu-children-closer');
              item.addEventListener('click', (e) => {
                  e.preventDefault();
                  subMenu.classList.add('show');
                  mobMnuHdr.classList.add('position-fixed');
              });
              chieldCloseBtn.addEventListener('click', (e) => {
                  e.preventDefault();
                  subMenu.classList.remove('show');
                  setTimeout(() => {
                      mobMnuHdr.classList.remove('position-fixed');
                  }, 10);
              });
              mobMnuCloser.addEventListener('click', (e) => {
                  subMenu.classList.remove('show');
                  setTimeout(() => {
                      mobMnuHdr.classList.remove('position-fixed');
                  }, 10);
              });
          });


          offcanv.addEventListener('hide.bs.offcanvas', event => {
            mobMnuHdr.classList.remove('position-fixed');
          });



      }else{
        let dropMenu = menu.querySelectorAll('.dropdown');
        let overlayEle = myDoc.createElement('div');
        overlayEle.className = 'overlay';

        myDoc.addEventListener('click', (e) => {
          let dropMenuTglr = e.target.closest('.dropdown-menu');
            if(!dropMenuTglr && overlayEle) {
              overlayEle.remove();
              header.classList.remove('overlay-active');
            }
        });

        dropMenu.forEach((item) => {
          item.addEventListener('show.bs.dropdown', event => {
              setTimeout(() => {
                let dropOverBg = myDoc.querySelector('.overlay');
                //! dropOverBg? myDoc.body.appendChild(overlayEle):'';
                if(!dropOverBg) {
                    myDoc.body.appendChild(overlayEle);
                    header.classList.add('overlay-active');
                }
              }, 0);
          });
        });
      }

    };

    menuDropdown('.nav-min-menu');
    window.addEventListener('resize', (e)=>{
        //console.log('resize');
        menuDropdown('.nav-min-menu');
    });

    let filter = myDoc.querySelector('.filter-btn');
    if(filter) {
      let eachClick = true;
      filter.addEventListener('click', (e) => {
        let filterPanl = myDoc.querySelector('.filter');
        let galView = myDoc.querySelector('.gallery-view');
        if(eachClick) {
          eachClick=false;
          filterPanl.classList.add('show');
          galView.classList.add('col-xl-10');
        } else {
          eachClick=true;
          filterPanl.classList.remove('show');
          galView.classList.remove('col-xl-10');
        }
      });

      let filterClose = myDoc.querySelector('.filter-close');
      filterClose.addEventListener('click', (e) => {
        let filterPanl = myDoc.querySelector('.filter');
        let galView = myDoc.querySelector('.gallery-view');
        filterPanl.classList.remove('show');
        galView.classList.remove('col-xl-10');
        eachClick=true;
      });
    }

    //search
    // const searchOpen = () => {
    //   const search = myDoc.querySelector('.search-header');
    //   let formInput = search.querySelector('.form-control');

    //   // Create overlay div
    //   let divEle = myDoc.createElement('div');
    //   divEle.className = 'search-overlay';
    //   myDoc.body.appendChild(divEle);
    //   search.classList.add('active');
    //   formInput.focus();
    // };

    // function mobileSerachDilog(getLoc) {
    //   const searchBtn = myDoc.querySelectorAll('.iconSearch');
    //   Object.keys(searchBtn).forEach(function(key) {
    //       searchBtn[key].addEventListener('click', function(e) {
    //           e.preventDefault();
    //           getLoc();
    //           searchOpen();
    //           return false;
    //       });
    //   });
    // }


    myDoc.addEventListener('click', function(event) {
        let searchManHdr = myDoc.querySelector('.search-header');
        let searchBtn = myDoc.querySelector('.iconSearch');
        let getLocMdl = myDoc.querySelector('#getLocModal');

        if (searchManHdr && !searchManHdr.contains(event.target) && (searchBtn && !searchBtn.contains(event.target)) && (getLocMdl && !getLocMdl.contains(event.target))) {
            let divEle = myDoc.querySelector('.search-overlay');
            if (divEle) {
                myDoc.body.removeChild(divEle); // Remove overlay
            }
            searchManHdr.classList.remove('active'); // Deactivate search form
        }
    });



    function fetchLocation(){
      function getLocation() {
        if (navigator.geolocation) {
          navigator.geolocation.getCurrentPosition(
            (position) => {
              alert(
                `Location accessed: Latitude ${position.coords.latitude}, Longitude ${position.coords.longitude}`
              );
            },
            (error) => {
              if (error.code === error.PERMISSION_DENIED) {
                alert("Location access denied by the user.");
              } else {
                alert("Error accessing location: " + error.message);
              }
            }
          );
        } else {
          alert("Geolocation is not supported by this browser.");
        }
      }
      const allowButton = myDoc.querySelector(".btn-alaowLoc");
      const denyButton = myDoc.querySelector(".btn-regFtchLoc");
      let getLocMdl =  new bootstrap.Modal(myDoc.querySelector('#getLocModal'), {});
      const getLocationMdlTgl = () =>{
        getLocMdl.toggle()
      }
      allowButton.onclick = () => {
        getLocation();
      };
      denyButton.onclick = () => {
        alert("You chose to deny location access.");
        getLocationMdlTgl();
      };
      if(! mediaQ.matches){
        myDoc.querySelector("#search")?.addEventListener("click", getLocationMdlTgl);
      }else{
        //mobileSerachDilog(getLocationMdlTgl);
      }
    };
    fetchLocation();




    //search By KeyUp
    let searchByKeyUp = myDoc.querySelectorAll('.searchByKeyUp');
    //scalable search function
    function filterFunction(element, input) {
      var  filter, ul, li, a, i;
      filter = input.value.toUpperCase();
      //div = document.getElementById("filter_dorpdown_list");
      a = element.getElementsByTagName("a");
      for (i = 0; i < a.length; i++) {
          txtValue = a[i].textContent || a[i].innerText;
          if (txtValue.toUpperCase().indexOf(filter) > -1) {
              a[i].style.display = "";
          } else {
              a[i].style.display = "none";
          }
      }
    }

    if(searchByKeyUp){
      Object.keys(searchByKeyUp).forEach(ele => {
        let input = searchByKeyUp[ele].querySelector(".form-control");
        let itemWrap = searchByKeyUp[ele].querySelector(".model-search");
        //console.log(input, itemWrap) ;
        if(input){
          input.addEventListener('keyup', (e) => {
            filterFunction(itemWrap, e.target);
          });
        }
      })
    }


    //init favourite
    const tooltipTriggerList = myDoc.querySelectorAll('[data-bs-toggle="tooltip"]');
    const tooltipList = tooltipTriggerList?[...tooltipTriggerList].map(tooltipTriggerEl => new bootstrap.Tooltip(tooltipTriggerEl)):null;


    //favourite
    //** Initialize tooltip on favourite **/
    const favouriteBtn = myDoc.querySelector('.favourites-icon');
    if(favouriteBtn){
      const bsTooltip = bootstrap.Tooltip.getOrCreateInstance(favouriteBtn);
      favouriteBtn.addEventListener('click', () => {
        const newContent = favouriteBtn.getAttribute('data-bs-title') === 'Add to favourites!'? 'Remove from Favourites!' : 'Add to favourites!';
        favouriteBtn.setAttribute('data-bs-title', newContent);
        bsTooltip.setContent({ '.tooltip-inner': newContent });
      });
    }

    myDoc.addEventListener('click', function(event) {
        if (event.target.classList.contains('favourites-icon')) {
            event.target.classList.toggle('active');
            if (event.target.classList.contains('active')) {
                event.target.parentElement.querySelector('.favourites-message').textContent = 'Added to favourites!';
                // event.target.setAttribute('data-bs-title', 'Remove to favourite');
                // bsTooltip.setContent({ '.tooltip-inner': 'Remove to favourite' });
                //new bootstrap.Tooltip(favouriteBtn);
            } else {
                event.target.parentElement.querySelector('.favourites-message').textContent = 'Removed from Favourites!';
                // event.target.setAttribute('data-bs-title', 'Add to favourite');
                // bsTooltip.setContent({ '.tooltip-inner': 'Add to favourite' });
            }
            event.target.parentElement.querySelector('.favourites-message').classList.add('active');
            setTimeout(() => {
                event.target.parentElement.querySelector('.favourites-message').classList.remove('active');
            }, 1000);
        }
    });

    //new bootstrap.Tooltip(favouriteBtn);


    // myDoc.addEventListener('click', function(event) {
    //     if (event.target.classList.contains('favourites-message')) {
    //         event.target.classList.remove('active');
    //     }
    // });

    // myDoc.addEventListener('click', function(event) {
    //     if (!event.target.closest('.favourites')) {
    //         myDoc.querySelectorAll('.favourites-message').forEach(function(message) {
    //             message.classList.remove('active');
    //         });
    //     }
    // });


    // const formGroup = myDoc.querySelectorAll('.form-group');
    // if(formGroup) {
    //   Object.keys(formGroup).forEach(i =>{
    //     let lable = formGroup[i].querySelector('label');
    //     let input = formGroup[i].querySelector('.form-control');
    //     if(lable) {
    //       input.addEventListener('blur', (e)=>{
    //         if(e.target.value!==''){
    //           e.target.classList.add('hasVal');
    //         }else{
    //           e.target.classList.remove('hasVal');
    //         }
    //       })
    //     }
    //   })
    // }

    //input select dropdown selectted image needs to show on image tag
    let selectScContainer = myDoc.querySelectorAll('.select-escort');
    if(selectScContainer) {
      Object.keys(selectScContainer).forEach(i=>{
          let image = selectScContainer[i].querySelector('.booking-img');
          let input = selectScContainer[i].querySelector('.form-control');
          if(image) {
            let prevSec = image.src;
            input.addEventListener('change', (e) => {
              let img = e.target.options[e.target.selectedIndex].getAttribute('data-value');
              if(img) {
                e.target.closest('.select-escort').querySelector('.booking-img').src = img;
              }else{
                e.target.closest('.select-escort').querySelector('.booking-img').src = prevSec;
                //console.log(prevSec);
              }
              //console.log(img);
            })
          }
      })
    };

    //custom upload
    const inputFilewrap = myDoc.querySelectorAll('.inputFile');
    if (inputFilewrap) {
        Object.keys(inputFilewrap).forEach(function(key) {
            const fileInput = inputFilewrap[key].querySelector('[type="file"]');
            const uploadBtn = inputFilewrap[key].querySelector('.uploadBtn');
            const displayArea = inputFilewrap[key].querySelector('.form-control');
            const originalLabel = uploadBtn.textContent;

            fileInput.addEventListener('change', function() {
                const existingItems = displayArea.querySelectorAll('.file-item');
                existingItems.forEach(item => item.remove());
                if (this.files.length > 0) {
                    uploadBtn.textContent = this.files.length + ' file(s) selected';

                    for (let i = 0; i < this.files.length; i++) {
                        const fileWrapper = document.createElement('span');
                        fileWrapper.className = 'file-item d-flex align-items-center mb-1';

                        const fileNameSpan = document.createElement('span');
                        fileNameSpan.textContent = this.files[i].name;

                        const removeBtn = document.createElement('button');
                        removeBtn.type = 'button';
                        removeBtn.className = 'btn removeUploadFile ms-2 d-none';
                        removeBtn.innerHTML = '&times;';
                        removeBtn.dataset.index = i;

                        fileWrapper.appendChild(fileNameSpan);
                        fileWrapper.appendChild(removeBtn);
                        displayArea.appendChild(fileWrapper);
                    }
                } else {
                    uploadBtn.textContent = originalLabel;
                }
            });


            myDoc.addEventListener('click', function(e) {
                const removeBtn = e.target.querySelector('.removeUploadFile');
                //console.log(removeBtn);
                if (removeBtn) {
                    e.stopPropagation();
                    const fileName = removeBtn.previousElementSibling.textContent;
                    //console.log(fileName);
                    removeFileByName(fileName, fileInput);
                    removeBtn.closest('.file-item').remove();
                    uploadBtn.textContent = fileInput.files.length > 0
                        ? fileInput.files.length + ' file(s) selected'
                        : originalLabel;
                }
            });
        });
    }

    function removeFileByName(fileName, fileInput) {
        const files = Array.from(fileInput.files);
        const updatedFiles = files.filter(file => file.name !== fileName);

        const dataTransfer = new DataTransfer();
        updatedFiles.forEach(file => dataTransfer.items.add(file));

        fileInput.files = dataTransfer.files;
    }



    // myDoc.addEventListener("DOMContentLoaded", () => {
    //   const hasAccepted = localStorage.getItem("adultAccepted");
    //   const myModal = new bootstrap.Modal(myDoc.querySelector('#warningsModal'), {});
    //   const regBtn = myDoc.querySelector('.btn-adultReg');
    //   const acptBtn = myDoc.querySelector('.btn-acptEnter');
    //   if (hasAccepted !== "true") {
    //     myModal.toggle();
    //   }

    //   regBtn.addEventListener('click', ()=>{
    //     window.location.href = "https://google.com";
    //   });

    //   acptBtn.addEventListener('click', ()=>{
    //     localStorage.setItem("adultAccepted", "true");
    //     myModal.toggle();
    //   });

    // });


    // const hoverToFadeSlide = () => {
    //   const sliderWraper = myDoc.querySelectorAll('.hoverSlider');


    //     Object.keys(sliderWraper).forEach(i=>{
    //       let tmout;
    //       let sliderItems = sliderWraper[i].querySelectorAll('.media-holder picture');
    //       let sliderImg = [];
    //       let curentIndex = 0;
    //       let itrImg;
    //       function makeSlider() {
    //         sliderImg = [];
    //         Object.keys(sliderItems).forEach((imgEle)=>{
    //           // console.log(bannerItem[imgEle]);
    //           sliderImg.push(sliderItems[imgEle]);
    //         });

    //         itrImg = function () {
    //           for(let i=0; i<sliderImg.length; i++){
    //             sliderImg[i].style.display='none';
    //           }
    //         }

    //         itrImg();
    //         sliderImg[0].style.display='block ';

    //         function incrementSlider() {
    //           if(curentIndex!=sliderImg.length){
    //             sliderImg[curentIndex].style.display='block';
    //           }else{
    //             sliderImg[0].style.display='block'; curentIndex=0
    //           }
    //         }

    //         tmout=setInterval(function(){
    //           curentIndex++;
    //           itrImg();
    //           incrementSlider();
    //         }, 1000);
    //       }

    //       function stopSliding() {
    //         clearInterval(tmout);
    //         itrImg();
    //         sliderImg[0].style.display='block';
    //         curentIndex=0;
    //       }

    //       sliderWraper[i].addEventListener('mouseenter', makeSlider);
    //       sliderWraper[i].addEventListener('mouseleave', stopSliding);

    //     });
    // }
    // hoverToFadeSlide();

    // const hoverToFadeSlide = () => {
    //     const sliderWraper = myDoc.querySelectorAll('.hoverSlider');

    //     Object.keys(sliderWraper).forEach(i => {
    //         let tmout;
    //         let sliderItems = sliderWraper[i].querySelectorAll('.media-holder picture');
    //         let sliderImg = [];
    //         let curentIndex = 0;

    //         function makeSlider() {
    //             sliderImg = [];
    //             Object.keys(sliderItems).forEach((imgEle) => {
    //                 sliderImg.push(sliderItems[imgEle]);
    //                 sliderItems[imgEle].classList.remove('active');
    //             });

    //             // Show first image
    //             //sliderImg[0].classList.add('active');
    //             sliderImg[0].classList.remove('active');
    //             sliderImg[1]?.classList.add('active');
    //             //curentIndex = (curentIndex + 1) % sliderImg.length;
    //             tmout = setInterval(function() {
    //                 // Remove active class from current image
    //                 sliderImg[curentIndex].classList.remove('active');

    //                 // Increment index or reset to 0
    //                 curentIndex = (curentIndex + 1) % sliderImg.length;

    //                 // Add active class to new image
    //                 sliderImg[curentIndex].classList.add('active');
    //             }, 1500);
    //         }

    //         function stopSliding() {
    //         clearInterval(tmout);

    //         // Remove active from all images except first
    //         sliderImg.forEach((img, index) => {
    //             img.classList.remove('active');
    //             if (index === 0) {
    //                 img.classList.add('active');
    //             }
    //         });

    //         curentIndex = 0;
    //         }

    //         sliderWraper[i].addEventListener('mouseenter', makeSlider);
    //         sliderWraper[i].addEventListener('mouseleave', stopSliding);
    //     });
    // }

    // hoverToFadeSlide();

    document.addEventListener('mouseover', function(e) {
        const sliderWrapper = e.target.closest('.hoverSlider');
        if (!sliderWrapper) return;

        // Check if we've already set up listeners for this wrapper
        if (sliderWrapper.dataset.sliderInitialized) return;
        sliderWrapper.dataset.sliderInitialized = 'true';

        let tmout;
        let curentIndex = 0;

        function makeSlider() {
            const sliderItems = sliderWrapper.querySelectorAll('.media-holder picture');
            const sliderImg = Array.from(sliderItems);

            if (sliderImg.length < 2) return;

            sliderImg.forEach(img => img.classList.remove('active'));
            sliderImg[0].classList.remove('active');
            sliderImg[1]?.classList.add('active');

            clearInterval(tmout);
            tmout = setInterval(function() {
                sliderImg[curentIndex].classList.remove('active');
                curentIndex = (curentIndex + 1) % sliderImg.length;
                sliderImg[curentIndex].classList.add('active');
            }, 1500);
        }

        function stopSliding() {
            clearInterval(tmout);
            const sliderImg = sliderWrapper.querySelectorAll('.media-holder picture');
            sliderImg.forEach((img, index) => {
                img.classList.remove('active');
                if (index === 0) img.classList.add('active');
            });
            curentIndex = 0;
        }

        sliderWrapper.addEventListener('mouseenter', makeSlider);
        sliderWrapper.addEventListener('mouseleave', stopSliding);

        // Trigger initial setup
        makeSlider();
    });


    const loadMoreServices = () => {
        const loadMoreBtn = document.querySelector('#loadMoreServices');
        const serviceItems = document.querySelectorAll('.service-item');
        let currentVisible = 9;
        const loadCount = 6;

        loadMoreBtn?.addEventListener('click', () => {
            loadMoreBtn.classList.add('loading');
            for (let i = currentVisible; i < currentVisible + loadCount && i < serviceItems.length; i++) {
                setTimeout(() => {
                    loadMoreBtn.classList.remove('loading');
                    serviceItems[i].classList.remove('d-none');
                }, 1000);
                //serviceItems[i].classList.remove('d-none');
            }
            currentVisible += loadCount;
            console.log(currentVisible);

            if (currentVisible >= serviceItems.length) {
                loadMoreBtn.style.display = 'none';
            }
        });
    }

    loadMoreServices();

    let rattingIBtn = document.querySelectorAll('.gallery-single-infoWrap-rating');
    rattingIBtn.forEach((item) => {
        item.addEventListener('click', () => {
            const collapseElement = document.getElementById(`${item.getAttribute('data-target')}`);
            if (!collapseElement) {
                console.error("Could not find collapseFive element");
                return;
            }

            const bsCollapse = bootstrap.Collapse.getOrCreateInstance(collapseElement);
            bsCollapse.show();


            function scrollHandler() {
                setTimeout(() => {
                    const targetElement = collapseElement.closest('.rettingItem');
                    console.log(targetElement.getBoundingClientRect().top);
                    if (targetElement) {
                        // Option 1: Precise calculation
                        const yOffset = -100; // Adjust this value
                        const y = targetElement.getBoundingClientRect().top + window.pageYOffset + yOffset;

                        window.scrollTo({
                            top: y,
                            behavior: 'smooth'
                        });

                        // Option 2: scrollIntoView with options
                        // targetElement.scrollIntoView({
                        //     behavior: 'smooth',
                        //     block: 'start'
                        // });
                    }
                    //collapseElement.removeEventListener('shown.bs.collapse', scrollHandler);
                }, 500);
            }
            scrollHandler();
            collapseElement.addEventListener('shown.bs.collapse', scrollHandler);
        })
    })



// Initialize the global cursor
// const cursor = document.querySelector('.global-custom-cursor');
// console.log(cursor);
// // Mouse move handler (position updates)
// document.addEventListener('mousemove', (e) => {
//   cursor.style.left = `${e.clientX}px`;
//   cursor.style.top = `${e.clientY}px`;
// });

// // Event delegation for hover effects
// document.body.addEventListener('mouseover', (e) => {
//     const staffCard = e.target.closest('.card-staff');
//     const naviAtag = e.target.closest('.nav-min-menu a') ||
//                     e.target.closest('footer a') ||
//                     e.target.closest('.price') ||
//                     e.target.closest('.age') ||
//                     e.target.closest('.custom-check__label') ||
//                     e.target.closest('.form-switch') ||
//                     e.target.closest('.clear_filter');
//     const btnContact = e.target.closest('.btn-contact') ||
//                         e.target.closest('.header-min-account') ||
//                         e.target.closest('.favourites ');
//     if (staffCard) {
//         //const isAvailable = staffCard.querySelector('.availability').classList.contains('available');
//         //cursor.textContent = isAvailable ? 'Available' : 'Away';
//         //cursor.className = `global-custom-cursor ${isAvailable ? 'available' : 'away'}`;
//         //cursor.style.opacity = '1';
//         //cursor.style.cssText = 'width: 80px; height: 80px; display: flex; align-items: center; justify-content: center; opacity: 1;';
//         cursor.style.cssText = 'width: 20px; height: 20px; opacity: 0.5; filter: blur(10px);';
//     }else if (naviAtag) {
//         cursor.style.cssText = 'width: 20px; height: 20px; opacity: 0.5; filter: blur(10px);';
//     }else if (btnContact) {
//         cursor.style.cssText = 'width: 40px; height: 40px; opacity: 0.5; filter: blur(10px);';
//     }
// });

// document.body.addEventListener('mouseout', (e) => {
//     if (!e.relatedTarget || !e.relatedTarget.closest('.card-staff')) {
//         //cursor.style.opacity  = '0.75';
//         cursor.style.cssText = 'width: auto; height: auto; display: flex; align-items: center; justify-content: center; opacity: 0.3;';
//         cursor.textContent = '';
//         cursor.className = 'global-custom-cursor';
//     }
// });

// // Optional: MutationObserver for dynamically loaded content
// const observer = new MutationObserver((mutations) => {
//     // Check if new staff cards were added
//     const addedNodes = mutations.flatMap(m => [...m.addedNodes]);
//     if (addedNodes.some(node => node.classList?.contains('card-staff'))) {
//         // No need to re-bind events thanks to delegation
//     }
// });

// observer.observe(document.body, {
//     childList: true,
//     subtree: true
// });

})(document);
